// none, error, warn, info, debug, verbose
import flatten, { unflatten } from "flat";
export default class Logger {
  constructor(options = {}) {
    const defaultOptions = {
      level: 4,
      usePrefix: false,
      colorized: true,
      maskValues: ["password", "token", "authorization"],
    };
    options = { ...defaultOptions, options };
    this.currentLevel = options.level;
    this.usePrefix = options.usePrefix;
    this.colorized = options.colorized;
    this.maskValues = options.maskValues;
    this.levels = {
      none: {
        level: 0,
        style: "color:white",
        prefix: "",
      },
      error: {
        level: 1,
        style: "color:red",
        prefix: this.usePrefix ? "error: " : "",
      },
      warn: {
        level: 2,
        style: "color:orange",
        prefix: this.usePrefix ? "warn: " : "",
      },
      info: {
        level: 3,
        style: "color:blue",
        prefix: this.usePrefix ? "info: " : "",
      },
      log: {
        level: 3,
        style: "color:grey",
        prefix: this.usePrefix ? "log: " : "",
      },
      verbose: {
        level: 4,
        style: "color:green",
        prefix: this.usePrefix ? "debug: " : "",
      },
    };
  }

  error(...args) {
    if (this.currentLevel < this.levels.error.level) return;
    const argums = this.mask(...args);
    if (this.colorized) {
      console.error(...this.format(this.levels.error, ...argums));
    } else {
      console.error(...args);
    }
  }

  warn(...args) {
    if (this.currentLevel < this.levels.warn.level) return;
    const argums = this.mask(...args);
    if (this.colorized) {
      console.warn(...this.format(this.levels.warn, ...argums));
    } else {
      console.warn(...args);
    }
  }

  log(...args) {
    if (this.currentLevel < this.levels.info.level) return;
    const argums = this.mask(...args);
    if (this.colorized) {
      console.log(...this.format(this.levels.log, ...argums));
    } else {
      console.log(...args);
    }
  }

  info(...args) {
    if (this.currentLevel < this.levels.info.level) return;
    const argums = this.mask(...args);
    if (this.colorized) {
      console.info(...this.format(this.levels.info, ...argums));
    } else {
      console.info(...args);
    }
  }

  debug(...args) {
    if (this.currentLevel < this.levels.verbose.level) return;
    const argums = this.mask(...args);
    if (this.colorized) {
      console.debug(...this.format(this.levels.verbose, ...argums));
    } else {
      console.debug(...argums);
    }
  }

  group(...args) {
    if (this.currentLevel < 3) return;
    console.group(...args);
  }

  groupEnd() {
    if (this.currentLevel < 3) return;
    console.groupEnd();
  }

  format(level, ...args) {
    let f = "";
    const formats = [];
    let cr = "";
    for (const arg of args) {
      if (typeof arg === "string" || typeof arg === "number") {
        f += `${cr}%c${level.prefix}${arg}`;
        formats.push(level.style);
      }
      if (typeof arg === "object") {
        f += `${cr}${level.prefix}%o\n`;
        formats.push(arg);
      }
      cr = "\n";
    }
    return [f, ...formats];
  }

  mask(...args) {
    const retval = [];
    for (const arg of args) {
      retval.push(this.maskArg(arg));
    }
    return retval;
  }

  maskArg(argument) {
    let arg = JSON.parse(JSON.stringify(argument));
    if (this.isArray(arg)) {
      for (const item in arg) {
        return this.maskArg(item);
      }
    } else {
      if (this.isObject(arg)) {
        const flat = flatten(arg ? arg : {});
        for (const key in flat) {
          if (
            this.maskValues.join("|").toLowerCase().indexOf(key.toLowerCase()) >
              -1 &&
            flat[key] !== "***"
          ) {
            flat[key] = "***";
          }
        }
        return unflatten(flat);
      } else {
        return arg;
      }
    }
  }

  isArray(value) {
    return Array.isArray(value);
  }

  isObject(value) {
    return value && !Array.isArray(value) && typeof value === "object";
  }
}
